var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileInstagramLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.968 0C5.358 0 0 5.358 0 11.968s5.358 11.968 11.968 11.968 11.968-5.359 11.968-11.968C23.936 5.358 18.577 0 11.968 0zM8.4 6.368a2.067 2.067 0 00-2.065 2.065v7.134c0 1.139.926 2.065 2.065 2.065h7.134a2.068 2.068 0 002.065-2.065V8.433a2.067 2.067 0 00-2.065-2.065H8.4zm7.134 12.83a3.636 3.636 0 003.632-3.631V8.433a3.636 3.636 0 00-3.632-3.632H8.4a3.636 3.636 0 00-3.632 3.632v7.134A3.636 3.636 0 008.4 19.199h7.134z",
    fill: "url(#mobileInstagramLogo_svg__paint0_radial_988_395)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.968 0C5.358 0 0 5.358 0 11.968s5.358 11.968 11.968 11.968 11.968-5.359 11.968-11.968C23.936 5.358 18.577 0 11.968 0zM8.4 6.368a2.067 2.067 0 00-2.065 2.065v7.134c0 1.139.926 2.065 2.065 2.065h7.134a2.068 2.068 0 002.065-2.065V8.433a2.067 2.067 0 00-2.065-2.065H8.4zm7.134 12.83a3.636 3.636 0 003.632-3.631V8.433a3.636 3.636 0 00-3.632-3.632H8.4a3.636 3.636 0 00-3.632 3.632v7.134A3.636 3.636 0 008.4 19.199h7.134z",
    fill: "url(#mobileInstagramLogo_svg__paint1_angular_988_395)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.968 0C5.358 0 0 5.358 0 11.968s5.358 11.968 11.968 11.968 11.968-5.359 11.968-11.968C23.936 5.358 18.577 0 11.968 0zM8.4 6.368a2.067 2.067 0 00-2.065 2.065v7.134c0 1.139.926 2.065 2.065 2.065h7.134a2.068 2.068 0 002.065-2.065V8.433a2.067 2.067 0 00-2.065-2.065H8.4zm7.134 12.83a3.636 3.636 0 003.632-3.631V8.433a3.636 3.636 0 00-3.632-3.632H8.4a3.636 3.636 0 00-3.632 3.632v7.134A3.636 3.636 0 008.4 19.199h7.134z",
    fill: "#5F787E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26 12a3.712 3.712 0 003.708 3.708A3.713 3.713 0 0015.676 12a3.712 3.712 0 00-3.708-3.708A3.712 3.712 0 008.26 12zm1.566 0c0-1.18.961-2.141 2.142-2.141 1.18 0 2.14.96 2.14 2.14 0 1.181-.96 2.142-2.14 2.142-1.18 0-2.142-.96-2.142-2.141z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.795 9.059a.878.878 0 010-1.755.878.878 0 010 1.755z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "mobileInstagramLogo_svg__paint0_radial_988_395",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 23.9355 -23.0629 0 4.599 23.936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70EA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FFC334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#FF5818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6634FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "mobileInstagramLogo_svg__paint1_angular_988_395",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.968 11.968) scale(11.9677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#FF29E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#560E4C",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopOpacity: 0.01
  })))));
}
export default SvgMobileInstagramLogo;